import React from 'react';
const notReasons = ['No porque no puedas.', 'No porque seas desordenada.', 'No porque te falte fuerza.'];
export function Letter() {
  return <section className="w-full bg-linen px-5 py-20 sm:px-8 sm:py-28" data-id="element-77" data-mp="44m3oxjq39ba">
      <div className="mx-auto max-w-2xl" data-id="element-78" data-mp="3vbq7zkohghg0">
        <p className="font-serif text-3xl italic text-terracotta sm:text-4xl" data-id="element-79" data-mp="3qdx5p2qaw7l0">
          Querida amiga,
        </p>

        <div className="mt-8 space-y-6 text-lg leading-relaxed text-cocoa" data-id="element-80" data-mp="3lelojsm0v02w">
          <p data-id="element-81" data-mp="3lgonx392e5ka">
            ¿Sientes que tu casa, tu mente y tu rutina están demasiado cargadas?
          </p>
          <p data-id="element-82" data-mp="3cmjq1zvijtv9">
            Tal vez tienes papeles acumulados, espacios desordenados, cosas
            pendientes, citas por recordar, pagos por organizar, ropa fuera de
            lugar, una cocina que siempre necesita atención y una lista mental
            que nunca termina.
          </p>
          <p data-id="element-83" data-mp="2xp9eyrms8q02">
            Y aunque sabes que quieres organizarte, muchas veces no sabes por
            dónde empezar.
          </p>
        </div>

        <ul className="my-10 space-y-2 border-l-2 border-clay/50 pl-6" data-id="element-84" data-mp="2wwr6d2kvkqyq">
          {notReasons.map(line => <li key={line} className="font-serif text-2xl text-ink sm:text-3xl" data-id="element-85" data-mp="31q27qo6x4fj9">
              {line}
            </li>)}
        </ul>

        <div className="space-y-6 text-lg leading-relaxed text-cocoa" data-id="element-86" data-mp="2rypgnysy1tea">
          <p className="font-medium text-ink" data-id="element-87" data-mp="2rwld5hyyiwej">
            Sino porque has estado cargando demasiado por mucho tiempo.
          </p>
          <p data-id="element-88" data-mp="3kn3cc7wk8dmo">
            Por eso fue creado <em className="font-serif text-xl not-italic text-terracotta" data-id="element-89" data-mp="3kmbq3nours92">“Organiza Tu Vida en 7 Días”</em>,
            un ebook práctico en español diseñado especialmente para mujeres
            hispanohablantes de 45+ que viven en Estados Unidos y desean
            recuperar paz, claridad y orden en su vida diaria.
          </p>
          <p data-id="element-90" data-mp="1ud1vka1xuxi2">
            Este no es un libro para hacerte sentir culpable. Es una guía
            sencilla, cálida y paso a paso para ayudarte a organizar tu mente,
            tu hogar, tu tiempo, tus rutinas y tu nueva etapa de vida —{' '}
            <strong className="font-semibold text-ink" data-id="element-91" data-mp="ryis7jsgjnd">sin presión y sin perfeccionismo</strong>.
          </p>
        </div>
      </div>
    </section>;
}